import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  Box,
  useDisclosure,
  Image
} from "@chakra-ui/react"
import { useTranslation } from "react-i18next"
import { TbMessageLanguage } from "react-icons/tb"
import { Flag } from "src/components/servicesPanel/auctions/auction.styled"
import { AvatarConfig } from "src/recoil/atoms/avatars/types"
import worldLanguagesSrc from "src/assets/images/worldLanguages.png"
import multiLanguageSrc from "src/assets/images/multiLanguage.png"

const getCountryCode = (code: string) => {
  const codes = code.split("-")
  if (codes.length < 2) return null

  const [, countryCode] = codes
  return countryCode
}

const getCountryFlag = (countryCode = "GB") => {
  return `/flags/${countryCode}.png`
}

const getLanguageName = (language: string = "") => {
  // Ensure the value is a string and handle splitting logic.
  if (typeof language === "string") {
    return language.split("(")[0].trim()
  }
  // Return an empty string if the value is not a string.
  return ""
}

export const LanguageIcon = ({ languages }) => {
  const languageModalState = useDisclosure()

  const renderFlagOrIcon = () => {
    if (languages.length === 1) {
      const lang = languages[0]
      const countryCode = getCountryCode(lang.languageCode)

      return (
        <Box paddingX={"1"} marginLeft={"auto"}>
          <Image
            alt={countryCode}
            src={getCountryFlag(countryCode)}
            width={["25px", "30px", "30px"]}
            height={["25px", "30px", "30px"]}
            style={{
              minWidth: "20px"
            }}
          />
        </Box>
      )
    }

    return (
      <Box
        paddingX={"1"}
        onClick={event => {
          event.stopPropagation()
          languageModalState.onOpen()
        }}
        position="relative"
        fontSize="1.2rem"
        cursor="pointer"
        marginLeft={"auto"}
      >
        <Image
          width={["25px", "30px", "30px"]}
          height={["25px", "30px", "30px"]}
          src={multiLanguageSrc}
        ></Image>
      </Box>
    )
  }

  return (
    <>
      {renderFlagOrIcon()}

      <AvatarLanguageModal
        isOpen={languageModalState.isOpen}
        onClose={languageModalState.onClose}
        languages={languages}
      />
    </>
  )
}

type AvatarDescriptionModalProps = {
  isOpen: boolean
  onClose: () => void
  languages: AvatarConfig["languages"]
}

const AvatarLanguageModal = ({
  isOpen,
  onClose,
  languages
}: AvatarDescriptionModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size={"xs"}>
      <ModalOverlay />
      <ModalContent color="white" background="black" border="1px solid yellow">
        <ModalHeader>Supported languages</ModalHeader>

        <ModalCloseButton
          _focus={{
            outline: "none"
          }}
        />

        <ModalBody>
          <Flex width="100%">
            <Flex
              width="100%"
              alignItems="center"
              overflow="auto"
              maxHeight={"400px"}
            >
              <Flex
                flexDirection="column"
                width={"unset"}
                overflow="auto"
                maxHeight="100%"
              >
                {languages?.map(item => {
                  const countryCode = getCountryCode(item.languageCode)

                  return (
                    <Flex
                      key={item.languagePosition}
                      cursor="pointer"
                      marginBottom="0.6rem"
                    >
                      <Flag
                        alt={t(countryCode)}
                        src={getCountryFlag(countryCode)}
                      />
                      <Text
                        marginLeft="1rem"
                        fontWeight="400"
                        fontSize="1.2rem"
                      >
                        {getLanguageName(t(item.language))}
                      </Text>
                    </Flex>
                  )
                })}
              </Flex>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default AvatarLanguageModal
